/* mime-db/index */ function _(require, module, exports) {
    /*!
     * mime-db
     * Copyright(c) 2014 Jonathan Ong
     * MIT Licensed
     */
    /**
     * Module exports.
     */
    module.exports = require(257) /* ./db.json */;
}
